import styles from "./UsersGraph.module.css";

import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { DASHBOARD_CHART_OPTIONS, TABLE_MIN_WIDTH } from "../../../../constant";
import CustomTabs from "../../../CommonComponents/CustomTabs";
import { Spin } from "antd";
import { formatNumbers } from "../../../../utils/NumberFormat";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  plugins: {
    title: {
      display: false,
      text: "Chart.js Bar Chart - Stacked",
    },
    legend: {
      display: false,
    },
    tooltip: {
      itemSort: function (a, b) {
        return b.datasetIndex - a.datasetIndex;
      },
      callbacks: {
        title: function (tooltipItem, data) {
          return tooltipItem[0]["label"] + " " + new Date().getFullYear();
        },
        labelColor: function (tooltipItem, chart) {
          return {
            backgroundColor: tooltipItem.dataset.hoverBackgroundColor[0],
          };
        },
        label: function (context) {
          var label = context.dataset.label || "";
          return label + " - " + formatNumbers(context.raw);
        },
      },
    },
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      stacked: true,
    },
    y: {
      stacked: false,
    },
  },
};

const labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const UsersGraph = ({ setHeight, data }) => {
  const divRef = useRef(null);
  const [filter, setFilter] = React.useState("All");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, []);

  useEffect(() => {
    var clientHeight = divRef?.current?.height;

    if (width < TABLE_MIN_WIDTH) {
      setHeight(55 * 6);
    }
    setHeight(clientHeight ? clientHeight - 31 : 55 * 6);
  }, [divRef, divRef?.current, divRef?.current?.height, setHeight, width]);

  const graphData = useMemo(() => {
    let datasets = [];

    if (filter !== "Candidates") {
      datasets.push({
        label: "Enterprise",
        data: data?.monthlyCounts?.enterpriseCounts || [],
        backgroundColor: "#CBCBCB",
        hoverBackgroundColor: ["#a6dd50"],
        borderRadius: 6,
      });
    }
    if (filter !== "Enterprise") {
      datasets.push({
        label: "Candidates",
        data: data?.monthlyCounts?.candidateCounts || [],
        backgroundColor: "#CBCBCB",
        hoverBackgroundColor: ["#0e2159"],
      });
    }

    return {
      labels,
      datasets: datasets,
    };
  }, [
    filter,
    data?.monthlyCounts?.enterpriseCounts,
    data?.monthlyCounts?.candidateCounts,
  ]);

  return (
    <div className={styles.chart_wrap}>
      <div className={styles.chart_header}>
        <div className={styles.label}>Total users</div>
        <CustomTabs
          defaultValue={filter}
          onChange={(value) => setFilter(value)}
          options={DASHBOARD_CHART_OPTIONS}
        />
      </div>
      {data?.monthlyCounts?.enterpriseCounts ? (
        <Bar ref={divRef} options={options} data={graphData} />
      ) : (
        <div className={styles.loader_wrap}>
          <Spin />
        </div>
      )}

      <div className={styles.chart_footer}>
        *Enterprise is classified as 1 user
      </div>
    </div>
  );
};

export default UsersGraph;
